import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import axios from 'axios';
import { injectIntl, FormattedMessage } from 'react-intl';
import { headers } from '../../../actions/defaults';
import { API_URL } from '../../../environment';

const buttonSx = theme => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.primary.contrastText,
  },
  '&:focus': {
    color: theme.palette.primary.contrastText,
  },
  '&:active': {
    color: theme.palette.primary.contrastText,
  },
});

const StripeLoginButton = () => {
  const [stripeLoginLink, setStripeLoginLink] = useState(null);

  useEffect(() => {
    axios
      .post(`${API_URL}/clinic_admin/stripe_login_links`, {}, headers())
      .then(response => {
        setStripeLoginLink(response.data.url);
      });
  }, []);

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        href={stripeLoginLink}
        rel="noopener noreferrer"
        sx={buttonSx}
      >
        <FormattedMessage defaultMessage="Go To Stripe" />
      </Button>
    </div>
  );
};

export default injectIntl(StripeLoginButton);
